import Stripe from "stripe";
import { sort } from "fast-sort";
import { NextSeo } from "next-seo";
import { GetServerSidePropsContext } from "next";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import RegistartionForm from "../../components/registration-form";
import {
  getEventProductId,
  isEventClosed,
  loadEventBySlug,
  EventRecord,
} from "../../utils/events";

const stripe = new Stripe(process.env.STRIPE_SECRET_KEY as string, {
  apiVersion: "2020-08-27",
});

interface RegisterPageProps {
  event: EventRecord;
  prices: any[];
  isClosed: boolean;
}

export default function RegisterPage({ event, prices, isClosed }: RegisterPageProps) {
  return (
    <div className="w-full block mx-auto">
      <NextSeo title={event.seoTitle || event.title} />
      <Navbar />
      <div className="pt-16">
        <RegistartionForm prices={prices} event={event} isClosed={isClosed} />
      </div>
      <Footer />
    </div>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const slug = context.params?.slug;
  if (!slug || typeof slug !== "string") {
    return { notFound: true };
  }

  const event = loadEventBySlug(slug);
  if (!event || event.status === "draft") {
    return { notFound: true };
  }

  if (isEventClosed(event)) {
    return {
      props: {
        event,
        isClosed: true,
        prices: [],
      },
    };
  }

  if (!event.requiresPayment) {
    return {
      props: {
        event,
        isClosed: false,
        prices: [],
      },
    };
  }

  const isPreview = process.env.VERCEL_ENV === "preview";
  const productId = getEventProductId(event, {
    isProduction: process.env.NODE_ENV === "production",
    isPreview,
  });
  if (!productId) {
    return { notFound: true };
  }

  const prices = await stripe.prices.list({
    product: productId,
    active: true,
  });

  return {
    props: {
      event,
      isClosed: false,
      prices: sort(prices.data).by([
        { desc: (p) => p.unit_amount },
        { desc: (p) => p.nickname },
      ]),
    },
  };
}
